import React from 'react';
import CountUp from 'react-countup';
import { numFormatter } from '@/utils/formatters';

interface AnimatedCountProps {
  count: number;
  className?: string;
  separator?: string;
  decimals?: number;
  suffix?: string;
  prefix?: string;
  duration?: number;
  isFormatted?: boolean;
  formattedDecimals?: number;
}

const AnimatedCount: React.FC<AnimatedCountProps> = ({
  count,
  className,
  separator = ',',
  decimals = 0,
  suffix = '',
  prefix = '',
  duration = 2,
  isFormatted = false,
  formattedDecimals = 0
}) => {
  return (
    <CountUp
      start={0}
      end={count}
      duration={duration}
      separator={separator}
      decimals={decimals}
      suffix={suffix}
      prefix={prefix}
      formattingFn={isFormatted ? (val) => numFormatter(val, formattedDecimals) : undefined}
      enableScrollSpy
      scrollSpyOnce
    >
      {({ countUpRef }) => (
        <span className={className} ref={countUpRef} />
      )}
    </CountUp>
  );
};

export default AnimatedCount;
